import styled from 'styled-components';

export const InfiniteScrollContainer = styled.div`
  width: 100%;
  overflow: auto;
  position: relative;
`;

export const LoaderWrapper = styled.div`
  position: relative;
`;
